import { isPrivate } from './isPrivate'

export const addPrivateEndpoint = () => {
  if (isPrivate()) {
    return '/private'
  }
  return ''
}
